import { create } from 'zustand';

type Theme = 'light' | 'dark';

interface ThemeStore {
  theme: Theme;
  toggle: () => void;
  set: (theme: Theme) => void;
}

function getInitialTheme(): Theme {
  if (typeof window === 'undefined') {
    return 'light';
  }
  const stored = localStorage.getItem('merritrac-portal-theme');
  if (stored === 'dark' || stored === 'light') {
    return stored;
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function applyTheme(theme: Theme): void {
  document.documentElement.classList.remove('light', 'dark');
  document.documentElement.classList.add(theme);
  localStorage.setItem('merritrac-portal-theme', theme);
}

export const useTheme = create<ThemeStore>((set) => {
  const initial = getInitialTheme();
  applyTheme(initial);

  return {
    theme: initial,
    toggle: (): void => {
      set((state) => {
        const next: Theme = state.theme === 'light' ? 'dark' : 'light';
        applyTheme(next);
        return { theme: next };
      });
    },
    set: (theme: Theme): void => {
      applyTheme(theme);
      set({ theme });
    },
  };
});
